const API = {
  //Offer Master
  getofferMaster: "/offer-master-current-active",
  //Banner Master
  getbannerMaster: "/banner-master-current-active",
  //login
  loginAuth: "/generate-auth-token",
  //translation
  translationApi: "/translation-content",
  // create categories
  getAll_categories: "/categories/all",
  // add-special api
  add_special: "add-special",
  //allocate brand
  allocate_Brand: "/allocate-brands",
  allocate_Brand_Id: "/allocate-brands-by-addSpecial-id",
  //supplier-brand-list
  supplier_brandList: "/productsById",
  //CMS
  getcms: "/cms",
  //client-product-mapping-by-client-Id
  getClientProductMappingbyId: "/client-product-mapping-by-client-Id",
  // member
  member: "/member",
  memberById: "/member-by-memberId",
  // generate token
  generate_token: "/v3/generateToken",
  // validate login token
  validate_login_token: "/v3/validateLoginToken",
  validate_login_token_v2: "validateLoginToken",
  redeemPoint: "/v3/redeemPoint",
  Enrollment: "/Enrollment",
  //product
  product_By_Id: "/products-by-client-id",

  //productById
  product_By_Product_Id: "/productsById",
  //sessionLogout
  sessionLogout: "/sso/SessionLogOut",

  //static points
  staticPoints: "/static-Points",
  //points
  pointsApi: "/client-configuration",

  //promotional
  promotional_api: "promotional-strip-current-active",
  // clientconfiguration
  clientconfiguration: "/client-configuration",
  clientbyid: "/client-master-by-Id",
  clientpaymentid: "/client-payment-gateway/filter",
  themeManagement: "/theme-management",

  //getMember Api
  getMemberApi: "/v3/GetMember",

  //switch account card api
  switchAccountApi: "/v3/switchAccount",
  // segmentId
  segmentApi: "/GetMappedSegmentWithMember",

  // otp-process
  sendOtp: "v3/sendOtp",
  sendSms: "/v3/sendSms",
  earnPoints: "/v3/postTransaction",
  validateOtp: "/v3/validateOtp",

  //order
  order: "/order",
  memberOrder: "/order-by-memberId",
  mailApi: "/v3/sendEmail",
  getMailApi: "/email-event-master",

  //Api config
  apiConfig: "/api-config",
  // supplier-capping
  suppliercapping: "/supplier-capping",
  //vendor order
  vendororder: "/vendor-order",
  // URL Shortner
  manageUrl: "/ManageUrl",
  orderCode: "/order-code",
  // Home page optimized APIs
  activeCategories: "/active-categories",
  activeSpecials: "/active-special",
  productList: "/productlist",
  trendingProducts: "/trending-products",

  //CustomerProductBudgetSummary
  customerProductBudgetSummary: "/CustomerProductBudgetSummary",

  //rewarsd widget
  clientMasterConfigData: "/client-master-config-data",
  //product-supplier-margin
  supplier_margin: "/product-supplier-margin",
  //supplier-master
  supplier_master: "/supplier-master",
};
export default API;
